var _stop, _stop2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgTplsSkeleton = function SvgTplsSkeleton(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 125,
    viewBox: "0 0 146 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V8C0 9.10457 0.895432 10 2 10H144C145.105 10 146 9.10457 146 8V2C146 0.895431 145.105 0 144 0H2ZM2 46C0.895431 46 0 46.8954 0 48V54C0 55.1046 0.895429 56 2 56H78C79.1046 56 80 55.1046 80 54V48C80 46.8954 79.1046 46 78 46H2ZM0 71C0 69.8954 0.895431 69 2 69H144C145.105 69 146 69.8954 146 71V77C146 78.1046 145.105 79 144 79H2C0.895432 79 0 78.1046 0 77V71ZM2 92C0.895431 92 0 92.8954 0 94V100C0 101.105 0.895432 102 2 102H144C145.105 102 146 101.105 146 100V94C146 92.8954 145.105 92 144 92H2ZM0 25C0 23.8954 0.895431 23 2 23H98C99.1046 23 100 23.8954 100 25V31C100 32.1046 99.1046 33 98 33H2C0.895429 33 0 32.1046 0 31V25ZM2 115C0.895431 115 0 115.895 0 117V123C0 124.105 0.895429 125 2 125H98C99.1046 125 100 124.105 100 123V117C100 115.895 99.1046 115 98 115H2Z",
    fill: "url(#".concat(_id, ")")
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 4.99999,
    y1: -0.00000487082,
    x2: 131,
    y2: 125,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#909AC3"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909AC3",
    stopOpacity: 0.1
  })))));
};
export default SvgTplsSkeleton;